import { MemoizedCarTypeSelect as CarTypeSelect } from './CarTypeSelect'

export default CarTypeSelect
